var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpgradePlanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124.453,
    height: 52.231,
    viewBox: "0 0 124.453 52.231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161631",
    "data-name": "Group 161631",
    transform: "translate(-233.773 -282.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6944",
    "data-name": "Path 6944",
    d: "M43.5,104.332H95.936a4.066,4.066,0,0,0,.864-.093,4.066,4.066,0,0,0,.864.093h29.961a4.033,4.033,0,1,0,0-8.066h-3.457a4.033,4.033,0,0,1,0-8.066h10.947a4.033,4.033,0,1,0,0-8.066H122.439a4.033,4.033,0,1,0,0-8.066H85.564a4.033,4.033,0,1,0,0-8.066H52.723a4.033,4.033,0,0,0,0,8.066H29.676a4.033,4.033,0,0,0,0,8.066h14.4a4.033,4.033,0,1,1,0,8.066H21.033a4.033,4.033,0,1,0,0,8.066H43.5a4.033,4.033,0,1,0,0,8.066Zm93.916,0a4.033,4.033,0,1,0-4.033-4.033A4.033,4.033,0,0,0,137.42,104.332Z",
    transform: "translate(216.773 224.168)",
    fill: "#f3f7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Plans_Outline_24px",
    transform: "translate(258.471 289.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plans_Outline_24px-2",
    "data-name": "Plans_Outline_24px",
    transform: "translate(13 4.193)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1094",
    "data-name": "Rectangle 1094",
    width: 44.042,
    height: 41.039,
    transform: "translate(0 0)",
    fill: "#787f88",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M39.228,35.438a4.131,4.131,0,0,1-4.292,3.945H7.332A4.13,4.13,0,0,1,3.04,35.438V5.935A4.131,4.131,0,0,1,7.332,1.99h27.6a4.13,4.13,0,0,1,4.292,3.945v29.5",
    transform: "translate(0.951 -0.023)",
    fill: "#fff",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeWidth: 2,
    strokeDasharray: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plans_Outline_24px-3",
    "data-name": "Plans_Outline_24px",
    transform: "translate(28.856 -6.999)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1094-2",
    "data-name": "Rectangle 1094",
    width: 44.042,
    height: 41.039,
    transform: "translate(0 0)",
    fill: "#787f88",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039-2",
    "data-name": "Path 1039",
    d: "M39.228,35.438a4.131,4.131,0,0,1-4.292,3.945H7.332A4.13,4.13,0,0,1,3.04,35.438V5.935A4.131,4.131,0,0,1,7.332,1.99h27.6a4.13,4.13,0,0,1,4.292,3.945v29.5",
    transform: "translate(1.144 0.046)",
    fill: "#fff",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_160890",
    "data-name": "Group 160890",
    transform: "translate(61.759 11.96) rotate(138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    d: "M6.039,0,0,6.039l6.039,6.039",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    d: "M0,0H17.88",
    transform: "translate(0.194 5.845)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradePlanIcon);
export default __webpack_public_path__ + "static/media/upgrade-plan-icon.2d3386ba195bf3fa3ffa88432a5489ce.svg";
export { ForwardRef as ReactComponent };